import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import styles from './ErrorMessage.less';
import WixRestErrorResponse from '@wix/restaurants-components-css-modules/dist/web/WixRestErrorResponse/WixRestErrorResponse';
import ContentConnector from '@wix/restaurants-components-css-modules/dist/shared/I18nProvider/ContentConnector';
import { isTab } from '../../../../shared/utils/A11yHelpers';
import { MODAL_A11Y_IDS } from '../../../../shared/constants';
import { getErrorType } from '../../../../shared/utils/ReservationHelpers';

export default ContentConnector({prefix: 'error_'})(class extends React.Component {
    static displayName = 'ErrorMessage';

    static propTypes = {
        response: PropTypes.object.isRequired,
        onConfirm: PropTypes.func.isRequired,
        isCustomDesign: PropTypes.bool,
        onButtonBlur: PropTypes.func,
        doneButtonRef: PropTypes.func
    };

    static defaultProps = {
        onButtonBlur: () => {},
        doneButtonRef: () => {}
    };

    componentDidMount() {
        this.content.focus();
    }

    render() {
        const { onConfirm, isCustomDesign, doneButtonRef } = this.props;
        const {
            errorType,
            title,
            description1,
            description2,
            button
        } = this._getTexts();

        const styleModule = _.cloneDeep(styles);

        if (isCustomDesign) {
            styleModule.wrapper = `${styles.wrapper} ${styles.custom}`;
        }

        return (
            <WixRestErrorResponse
                ref={el => this.content = el}
                titleId={MODAL_A11Y_IDS.TITLE_ID}
                descriptionId={MODAL_A11Y_IDS.DESCRIPTION_ID}
                errorType={errorType}
                doneButtonRef={doneButtonRef}
                onButtonKeyDown={this._onButtonKeyDown}
                title={title}
                descriptions={[description1, description2]}
                button={button}
                onButtonClick={onConfirm}
                styleModule={styleModule}/>
        );
    }

    _getTexts = () => {
        const { content, response } = this.props;
        const errorType = getErrorType(response);
        const title = content.get('title');
        let button = null;
        let description1 = null;
        let description2 = null;

        switch (errorType) {
            case 'invalid_data':
            case 'internal':
                description1 = content.get('description1');
                description2 = content.get('description2');
                button = content.get('ok_button');
                break;
            default:
                description1 = content.get('default_description');
                description2 = content.get('default description2');
                button = content.get('default_ok');
        }

        return {
            errorType,
            title,
            description1,
            description2,
            button
        };
    };

    _onButtonKeyDown = (e) => {
        const { onButtonBlur } = this.props;
        const { tab, shiftKey } = isTab(e);

        if (tab && !shiftKey) {
            onButtonBlur(e);
            e.preventDefault();
        }
    };
});
